export default {
  container: 'mb-[16px] flex items-start w-full',
  inputContainer: 'flex flex-col border border-color-border border-solid w-full rounded p-[8px] focus-within:border-color-blue',
  input: 'font-inter w-full outline-none resize-none',
  actionButtons: 'flex align-center justify-end gap-[8px]',
  button: 'max-w-min px-[8px] py-[4px] text-[14px] bg-[#EC6D25] rounded text-color-white mt-[12px] cursor-pointer hover:brightness-110',
  buttonDisabled: 'opacity-75 pointer-events-none',
  cancelButton: 'max-w-min px-[8px] py-[4px] text-[14px] border border-color-border rounded mt-[12px] text-color-text-grey cursor-pointer hover:brightness-110',
};
